// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Analysis Summary node registration.
 */
import { registerPipelineNode } from '../../../core/pipeline-registry'
import { AnalysisSummaryAdminView, AnalysisSummaryWorkflowNode } from './components'

registerPipelineNode({
  id: 'analysis.analysis_summary',
  manifest: {
    id: 'analysis.analysis_summary',
    name: 'Analysis Summary',
    category: 'analysis',
    icon: 'FileText',
    description: 'LLM-driven summary node that consumes extraction outputs.',
    order: 40,
  },
  WorkflowNode: AnalysisSummaryWorkflowNode,
  AdminConfig: AnalysisSummaryAdminView,
})
